import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Container } from './Container';
import { Doodle } from './Doodle';
import { comparisonRows } from '../data/landing';
function Without({
  children
}: {
  children: React.ReactNode;
}) {
  return <span className="flex items-start gap-2 text-navy-soft" data-id="element-59" data-mp="2plgr4anw4el2">
      <XIcon aria-hidden="true" strokeWidth={3} className="mt-1 h-4 w-4 shrink-0 text-pink" data-id="element-60" data-mp="2unpkv98l7ko8" />
      {children}
    </span>;
}
function With({
  children
}: {
  children: React.ReactNode;
}) {
  return <span className="flex items-start gap-2 font-semibold text-navy" data-id="element-61" data-mp="3mcsruwruz94k">
      <CheckIcon aria-hidden="true" strokeWidth={3} className="mt-1 h-4 w-4 shrink-0 text-teal" data-id="element-62" data-mp="38eb4j05v7yn6" />
      {children}
    </span>;
}
export function ComparisonTable() {
  return <section aria-labelledby="comparison-title" className="relative overflow-hidden bg-teal py-16 sm:py-20 lg:py-24" data-id="element-63" data-mp="1wyvzra7f02hi">
      <Doodle kind="rays" className="absolute left-[6%] top-12 hidden h-8 w-8 -rotate-12 lg:block" data-id="element-64" data-mp="21yiczjn8tiqb" />
      <Doodle kind="leaf" className="absolute right-[6%] top-14 hidden h-9 w-9 rotate-12 lg:block" data-id="element-65" data-mp="2dwvttqdnrbqr" />
      <Container data-id="element-66" data-mp="29wbwomt3484m">
        <div className="mx-auto max-w-3xl text-center" data-id="element-67" data-mp="29wvfs6uh12k8">
          <p className="font-display text-xs font-extrabold uppercase tracking-[0.14em] text-white sm:text-sm" data-id="element-68" data-mp="2nvldnop4769n">Con Plan B incluido</p>
          <h2 id="comparison-title" className="mt-3 text-balance font-heading text-[2rem] font-black leading-[1.1] text-white sm:text-4xl lg:text-[2.85rem]" data-id="element-69" data-mp="2iw8q11qf5v60">
            Porque ninguna semana sale <span className="rounded-lg bg-sun px-2 text-navy" data-id="element-70" data-mp="2stwkrro0z2o6">perfecta</span>
          </h2>
        </div>

        {/* Desktop: tabla */}
        <div className="mx-auto mt-10 hidden max-w-5xl overflow-hidden rounded-3xl bg-white shadow-soft md:block" data-id="element-71" data-mp="36nxe25w7jxh5">
          <table className="w-full text-left text-base" data-id="element-72" data-mp="3gk0py3gv3aha">
            <thead data-id="element-73" data-mp="3gkilexvp9ko5">
              <tr className="border-b border-teal-soft bg-cream" data-id="element-74" data-mp="3ghwcatt5ux3t">
                <th scope="col" className="px-6 py-4 font-heading text-sm font-extrabold uppercase tracking-wide text-navy" data-id="element-75" data-mp="3bmqt42r57wjf">Situación</th>
                <th scope="col" className="px-6 py-4 font-heading text-sm font-extrabold uppercase tracking-wide text-navy-soft" data-id="element-76" data-mp="3nngq5siwwrk9">Sin sistema</th>
                <th scope="col" className="px-6 py-4 font-heading text-sm font-extrabold uppercase tracking-wide text-teal-dark" data-id="element-77" data-mp="3slih0zmkxv6a">Con 30 Días</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-teal-soft" data-id="element-78" data-mp="67qq1qh1t7f0">
              {comparisonRows.map(r => <tr key={r.situation} data-id="element-79" data-mp="a7sta42fm8we">
                  <th scope="row" className="px-6 py-4 font-heading font-extrabold text-navy" data-id="element-80" data-mp="a6r8h7vm681h">{r.situation}</th>
                  <td className="px-6 py-4" data-id="element-81" data-mp="f5uccozuy87v"><Without data-id="element-82" data-mp="k6i0n2wpcaye">{r.without}</Without></td>
                  <td className="bg-teal-light/25 px-6 py-4" data-id="element-83" data-mp="k5yuskkbtd0q"><With data-id="element-84" data-mp="2gza27jo4fj1s">{r.with}</With></td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Mobile: tarjetas apiladas */}
        <ul className="mt-10 grid gap-3 md:hidden" data-id="element-85" data-mp="2m07mc1soyn5x">
          {comparisonRows.map(r => <li key={r.situation} className="rounded-3xl bg-white p-5 shadow-soft" data-id="element-86" data-mp="2egour75dtllq">
              <p className="font-heading text-lg font-extrabold text-navy" data-id="element-87" data-mp="29may71ezh8fh">{r.situation}</p>
              <div className="mt-3 grid gap-2 text-base" data-id="element-88" data-mp="24pap0hmu7pk5">
                <Without data-id="element-89" data-mp="1zq7uvs8eb3qy">{r.without}</Without>
                <With data-id="element-90" data-mp="1zr97w28z20bb">{r.with}</With>
              </div>
            </li>)}
        </ul>
      </Container>
    </section>;
}